<template>
    <div>
        <schedule-x-calendar v-if="showSchedule" :calendarApp="getCalendarApp()">
            <template #timeGridEvent="{ calendarEvent }">
                <common-calendar-x-event :calendarEvent="calendarEvent"></common-calendar-x-event>
            </template>
        </schedule-x-calendar>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import { ScheduleXCalendar } from '@schedule-x/vue'
    import { createCalendar, createViewDay, createViewWeek } from '@schedule-x/calendar'
    import CalendarEventAPI from 'api/CalendarEventAPI'
    import { createEventsServicePlugin } from '@schedule-x/events-service'
    import { createCalendarControlsPlugin } from '@schedule-x/calendar-controls'
    import ReservationSortFilterEnum from 'enums/reservation_sort_filter.enum'
    import ReservationStatusFilterEnum from 'enums/reservation_status_filter.enum'
    import TranslateMixin from 'mixins/TranslateMixin'
    import availabilityTransformer from 'transformers/availabilityTransformer'
    import { event } from 'vue-gtag'

    export default {
        mixins: [TranslateMixin],
        components: {
            ScheduleXCalendar,
        },
        props: {
            currentDate: { type: Object, required: true },
            excludedOfferIds: { type: Array, default: () => [] },
            userId: { type: Number, default: undefined },
        },
        data() {
            return {
                eventsServicePlugin: createEventsServicePlugin(),
                calendarControls: createCalendarControlsPlugin(),
                isSingleEventModalOpen: false,
                selectedCalendarEvent: undefined,
                showSchedule: true,
                activeView: 'day',
            }
        },
        computed: {
            statusOptions() {
                return Object.values(ReservationStatusFilterEnum)
                    .filter(
                        (status) =>
                            status.value !== ReservationStatusFilterEnum.CANCELED.value &&
                            status.value !== ReservationStatusFilterEnum.UNAVAILABLE.value,
                    )
                    .map((status) => status.value)
            },
        },
        methods: {
            loadSchedule() {
                const query = {
                    status: this.statusOptions,
                    orderBy: ReservationSortFilterEnum.RESERVATON_TIME_ASC.value.orderBy,
                    wayDefinition: ReservationSortFilterEnum.RESERVATON_TIME_ASC.value.wayDefinition,
                    onlyPerformer: true,
                    loadEventItems: true,
                    performerId: this.userId,
                    excludeOfferIds: this.excludedOfferIds,
                }
                const dateRange = this.calendarControls.getRange()
                this.activeView =
                    dayjs(dateRange.start).format('YYYY-MM-DD') === dayjs(dateRange.end).format('YYYY-MM-DD') ? 'day' : 'week'

                if (this.activeView === 'week') {
                    query.dateFrom = dateRange.start || dayjs().format('YYYY-MM-DD')
                    query.dateTo = dateRange.end || dayjs().format('YYYY-MM-DD')
                } else {
                    query.dateFrom = this.currentDate.date || dayjs().format('YYYY-MM-DD')
                    query.dateTo = this.currentDate.date || dayjs().format('YYYY-MM-DD')
                }
                return CalendarEventAPI.getReservationsReceived(query).then((response) => {
                    const events = response.page.map((event) => {
                        return {
                            ...event,
                            id: event.id,
                            title: this.getTranslation(event.availabilityOffer.linkedOffer.titleTextContent),
                            start: `${event.date} ${availabilityTransformer.minutesDateToLocalTZTime(
                                event.startTime,
                                event.date,
                            )}`,
                            end: `${event.date} ${availabilityTransformer.minutesDateToLocalTZTime(
                                event.allowOverlapAfterMinutes ? event.startTime + event.allowOverlapAfterMinutes : event.endTime,
                                event.date,
                            )}`,
                            date: event.date || dayjs().format('YYYY-MM-DD'),
                        }
                    })
                    this.eventsServicePlugin.set(events)
                })
            },

            getCalendarApp() {
                return createCalendar({
                    views: [createViewDay(), createViewWeek()],
                    events: [],
                    defaultView: createViewDay.name,
                    selectedDate: dayjs().format('YYYY-MM-DD'),
                    isDark: false,
                    monthGridOptions: {
                        nEventsPerDay: 8,
                    },
                    isResponsive: true,
                    callbacks: {
                        onRangeUpdate: () => {
                            this.loadSchedule()
                        },
                        onEventClick: (calendarEvent) => {
                            this.emitEvent({
                                name: 'calendar-event-clicked',
                                payload: calendarEvent,
                            })
                        },
                    },
                    plugins: [this.eventsServicePlugin, this.calendarControls],
                })
            },
        },

        watch: {
            userId: {
                handler() {
                    this.showSchedule = false
                    setTimeout(() => {
                        this.showSchedule = true
                        this.loadSchedule(event).then(() => {
                            this.calendarControls.setDate(this.currentDate.date)
                        })
                    }, 0)
                },
            },

            excludedOfferIds() {
                this.loadSchedule()
            },
        },

        mounted() {
            this.loadSchedule()
        },
    }
</script>

<style lang="scss"></style>
